import { FC } from 'react';

import { AuthGuardProvider, useAuthGuard } from '@components/AuthGuard';
import useAuth from '@hooks/useAuth';
export type AppAuthGuardProviderProps = {
  children?: React.ReactNode;
};
export const AppAuthGuardProvider: FC<AppAuthGuardProviderProps> = ({ children }) => {
  const auth = useAuth();

  const authGuardProps = useAuthGuard({
    scopes: auth?.scopes ?? [],
    raiseError: false,
  });

  return <AuthGuardProvider {...authGuardProps}>{children}</AuthGuardProvider>;
};

export default AppAuthGuardProvider;
